export function exitPlayback({ guard, player, breakpoint, vodId, completed, save, notify, close }) {
  if (guard.current) return;
  guard.current = true;
  const duration = Number(player?.duration());
  const time = Number(breakpoint || player?.currentTime() || 0);
  const finished = completed || (duration > 0 && time > 0 && (time >= duration * 0.95 || duration - time <= 30));
  const bookmark = Math.floor(finished ? duration : time);
  // Exit first. Saving must never hold the customer's navigation hostage.
  const saved = vodId && Number.isFinite(bookmark) && bookmark >= 0
    ? Promise.resolve().then(() => save(vodId, bookmark)).then(() => { notify(true); return true; }).catch(() => false)
    : Promise.resolve(false);
  close(true, saved);
}
